let enabledOverride;
export function setGapDiagnosticsEnabled(enabled) {
    enabledOverride = enabled;
}
export function isGapDiagnosticsEnabled() {
    if (enabledOverride !== undefined) {
        return enabledOverride;
    }
    try {
        return (globalThis.localStorage?.getItem('gapDiagnostics') === '1' ||
            new URL(globalThis.location?.href ?? '').searchParams.get('gapDiagnostics') === 'true');
    }
    catch {
        return false;
    }
}
export function logGapDiagnostic(layer, event = {}) {
    if (!isGapDiagnosticsEnabled())
        return;
    const payload = {
        layer,
        timestampMs: performance.now(),
        ...event,
    };
    console.log('[gap-diagnostics]', JSON.stringify(payload));
}
